// @flow
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import AppsUtil from '../../../utils/AppsUtil';
import React, {Component} from 'react';
import FirstAppDownloadCard from '../FirstAppDownloadCard/FirstAppDownloadCard';
import './GetFirstAppPage.scss';
import {productCardDetails} from '../appPickerConstants';
import Button from '@react/react-spectrum/Button';
import AppsAnalytics from '../../../analytics/AppsAnalytics';

type Props = {
	getPlatformAppInfo: Function,
	getAppPlatform: Function,
	getAppBtnType: Function,
	history: Object,
	environment: string,
	intl: Object,
	routeSchema: Object,
	routeParams: Object,
	imsData: Object
};

export default class GetFirstAppPage extends Component<Props> {
	componentDidMount() {
		this.sendAnalytic('render', 'page');
	}

	sendAnalytic(type: string, subType: string) {
		const appsAnalytics = new AppsAnalytics(this.props.environment);
		appsAnalytics.initAnalytics();
		appsAnalytics.genericAnalyticEvent({}, type, subType, undefined, undefined, undefined, undefined, 'Welcome', 'App Picker');
	}

	renderAppDownloadCards() {
		return Object.keys(productCardDetails).map(app => <FirstAppDownloadCard key={`${app}-download-card`} {...this.props} app={app} />);
	}

	renderGuidePage() {
		this.props.history.push(AppsUtil.routeConstructor(this.props.routeSchema.appsPDPTabRoute, this.props.routeParams.mainAppsTab, this.props.routeParams.product, 'categories'));
	}

	onGuideMeClick = () => {
		this.sendAnalytic('click', 'guide-me');
		this.renderGuidePage();
	}

	render() {
		const welcomeMsg = this.props.intl.formatMessage({id: 'apps.appPickerPhotoPlan.welcomeMsg'}, {userName: this.props.imsData.name});
		return (
			<div className='get-first-app'>
				<h2 className='app-picker-welcome-message'>{welcomeMsg}</h2>
				<div className='first-app-download-cards'>{this.renderAppDownloadCards()}</div>
				<div className='first-app-guide'>
					<img src='/assets/apps/appsPickerTest/Lr-illustration.png' className='first-app-guide-img' alt={this.props.intl.formatMessage({id: 'apps.appPickerPhotoPlan.guideMe.button'})}/>
					<div className='first-app-guide-text'>
						<h1>{this.props.intl.formatMessage({id: 'apps.appPickerPhotoPlan.guideMe.heading'})}</h1>
						<p>{this.props.intl.formatMessage({id: 'apps.appPickerPhotoPlan.guideMe.subHeading'})}</p>
						<Button variant='primary' label={this.props.intl.formatMessage({id: 'apps.appPickerPhotoPlan.guideMe.button'})}
							onClick={this.onGuideMeClick}/>
					</div>
				</div>
			</div>
		);
	}
}